module.exports = __webpack_public_path__ + "img/right.d09a1525.svg";